package com.nonopn.skywatcher.common.login.pages

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.login.LocalAppMainTitle
import com.nonopn.skywatcher.common.login.LocalLoginCaller
import com.nonopn.skywatcher.common.login.sub.MainNotLoggedScreen
import eu.codlab.compose.widgets.systemBackground
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteMain : RouteParameterTo

object RouterMain : RouterNoParameters<RouteMain>(RouteMain::class) {
    override fun routeFrom(parameters: RouteMain) = "/main"

    @Composable
    override fun Show(parameters: RouteMain) {
        RouteMainImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteMain,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteLogin

    override fun isMatching(route: String) = route == "/main"

    override fun navigateFrom(path: String) = RouteMain
}

class RouteMainImpl : Route<RouteMain>(
    route = "/main",
    params = RouteMain,
) {
    @Composable
    override fun scene() {
        println("RouteMainImpl called")
        Column(
            modifier = Modifier
                .fillMaxSize()
                .systemBackground()
        ) {
            MainNotLoggedScreen(
                appMainTitle = LocalAppMainTitle.current,
                loginCaller = LocalLoginCaller.current
            )
        }
    }
}
